import { combineReducers } from '@reduxjs/toolkit';
import minicartSaga from '@state/features/minicart.saga';
import minicartSlice from '@state/features/minicart.slice';
import { all, fork } from 'redux-saga/effects';
import userInfoSaga from './userInfo.saga';
import userInfoSlice from './userInfo.slice';
export const minicartRootReducer = combineReducers({
    userInfo: userInfoSlice.reducer,
    minicart: minicartSlice.reducer,
});
export function* minicartRootSaga() {
    yield all([fork(minicartSaga), fork(userInfoSaga)]);
}
